<template>
  <div class="tech-empowerment py-80px">
    <div class="block-content">
      <block-title :en="tech.title.en" :title="tech.title.value" :sub="tech.title.sub"></block-title>

      <div class="card-container mt-80px">
        <div class="card-item flex gap-5% py-60px px-108px" :class="{ 'flex-row-reverse': index % 2 }" v-for="(item, index) in tech.list" :key="item.title">
          <div class="text flex-col justify-center w-54%" :class="{ 'pl-90px': index % 2 }">
            <div class="en pl-19px">{{ item.en }}</div>
            <div class="zh pl-19px mt-8px">{{ item.title }}</div>
            <div class="desc pl-19px mt-24px">{{ item.description }}</div>
            <div class="options pl-19px mt-24px">
              <div class="option" v-for="option in item.options" :key="option">{{ option }}</div>
            </div>
          </div>
          <div class="img w-40%">
            <img class="wh-full object-contain" :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['globalData']),
    tech() {
      return this.globalData['airport-vehicle-management'].techEmpowerment;
    }
  }
};
</script>

<style lang="scss" scoped>
.tech-empowerment {
  background: url('@/asset/index/csb_index_30.png') no-repeat center/cover;
  * {
    box-sizing: border-box;
  }
  .card-item {
    min-height: 438px;
    background: white;
    &:nth-child(2n) {
      background: #f1f6ff;
    }
  }
  .en {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    font-size: 18px;
    color: #dddddd;
    line-height: 24px;
  }
  .zh {
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-weight: 600;
    font-size: 32px;
    color: #282938;
    line-height: 32px;
  }
  .desc {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    line-height: 36px;
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  .option {
    min-width: 140px;
    padding-left: 18px;
    position: relative;
    font-size: 16px;
    color: #333333;
    line-height: 28px;
    &::before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      left: 0;
      top: 10px;
      border-radius: 50%;
      background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
    }
  }
  .img {
    height: 318px;
  }
}
</style>
